import ContactInfoContent from './ContactInfoContent';

export default ContactInfoContent;
